/**
 * Drops key/value rows where both key and value are empty after trim.
 * Editor sentinel rows (empty key for "type to add") should not be persisted;
 * stripping on load also fixes legacy saved data with duplicate blank rows.
 */
export function stripBlankKvRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.filter(
    (r) => String(r?.key ?? '').trim() !== '' || String(r?.value ?? '').trim() !== ''
  );
}

/** Rows safe for API persistence (no UI-only `_id`, no blank sentinel rows). */
export function kvRowsForApi(rows) {
  return stripBlankKvRows(rows).map(({ _id, ...row }) => row);
}

export function makeKvRowId(prefix) {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/** Trailing row with empty key — type in Key to add the next row (see RequestBuilder params). */
export function ensureTrailingEmptyKvRow(rows, idPrefix) {
  const cleaned = stripBlankKvRows(rows);
  const base =
    cleaned.length > 0
      ? cleaned.map((r) => ({ ...r }))
      : [{ key: '', value: '', enabled: true, _id: `${idPrefix}-0-${Date.now()}` }];
  const last = base[base.length - 1];
  if (last.key !== '') {
    base.push({
      key: '',
      value: '',
      enabled: true,
      _id: makeKvRowId(idPrefix),
    });
  }
  return base;
}
